/**
 * 主题色
 */

/**
 *   --main-color 主题色 [深色字体和线]
 *   --main-1 [网站地图底色]
 *   --main-2 [相对于3较浅,用于渐变]
 *   --main-3 [按钮主题色]
 *   --main-4 [影片头部颜色，深]
 */

// acx
export const ACX_COLOR: Record<string, string> = {
  '--main-color': '#A37C3C',
  '--main-footer-bg': '#F7F5F1',
  '--main-footer-protocol-bg': '#f2ebde',
  '--main-footer-text': '#333',
  '--main-footer-protocol-text': '#333',
  '--main-1': '#FFFDF7',
  '--main-2': '#FAE099',
  '--main-3': '#CAAC56',
  '--main-4': '#A78627',
  '--main-5': '#F8F8F8',
};

// 博纳
export const BONA_COLOR: Record<string, string> = {
  '--main-color': '#003A79',
  '--main-footer-bg': '#F1F4F7',
  '--main-footer-protocol-bg': '#DEE6F2',
  '--main-footer-text': '#666',
  '--main-footer-protocol-text': '#333',
  '--main-1': '#FAFDFF',
  '--main-2': '#08A4EB',
  '--main-3': '#006ECD',
  '--main-4': '#0051A9',
  '--main-5': '#F8F8F8',
};

// 银河
export const GALAXY_COLOR: Record<string, string> = {
  '--main-color': '#886D40',
  '--main-footer-bg': '#151515',
  '--main-footer-protocol-bg': '#f2ebde',
  '--main-footer-text': '#fff',
  '--main-footer-protocol-text': '#fff',
  '--main-1': '#FFFDF7',
  '--main-2': '#A37C3C',
  '--main-3': '#896E40',
  '--main-4': '#A4844E',
};
